import { createSlice } from "@reduxjs/toolkit";

export const UserCurrentStateSlice = createSlice({
  name: "UserCurrentState",
  initialState: {
    isNewUser: window.sessionStorage.getItem("user_current_state")
      ? window.sessionStorage.getItem("user_current_state") === 45
      : true,
    data: {},
    userInfo: {},
  },
  reducers: {
    setUserIsNewUser: (state, { payload }) => {
      state.isNewUser = payload;
    },
    setUserCurrentState: (state, { payload }) => {
      state.data = payload;
      state.isNewUser = payload.code === 45;
    },
    setUserInfo: (state, { payload }) => {
      state.userInfo = payload;
    },
  },
});

export const { setUserCurrentState, setUserInfo, setUserIsNewUser } = UserCurrentStateSlice.actions;

export const UserCurrentStateReducer = UserCurrentStateSlice.reducer;
